import { conditions, secondsToHMS } from "helpers";
import { ConditionName } from "interfaces";
import { useAppSelector } from "redux-share/hooks";
import { shallowEqual } from "react-redux";

const ElapsedTime = () => {
    const { duration, currentTime } = useAppSelector(
        ({ controller: { duration, currentTime, showMiniPlayer } }) => ({ duration, currentTime, showMiniPlayer }),
        shallowEqual
    );
    useAppSelector(
        ({ videoData: { isComplexPortrait, videoElementSizeInfo, params } }) => ({ isComplexPortrait, videoElementSizeInfo, params }),
        shallowEqual
    );

    return (
        <>
            <div
                className={`pl-relative pl-left-2 ${
                    conditions(ConditionName.isComplexPortrait) ? "pl-text-gray-800" : "!pl-text-dark-5"
                } dark:pl-text-dark-5 pl-w-full pl-max-w-max ${conditions(ConditionName.isMiniPlayer) && "pl-text-[12px] pl-font-normal"}`}
            >
                <span>{secondsToHMS(duration)}</span>
                <span> / </span>
                <span>{secondsToHMS(currentTime)}</span>
            </div>
        </>
    );
};

export default ElapsedTime;
